import * as PIXI from "pixi.js";
import Game from "../screens/Game";
import MiddleLayer from "./MiddleLayer";
import TopLayer from "./TopLayer";
import UILayer from "./UILayer";
import HowToPlayLayer from "./HowToPlayLayer";
import GridDataManager from "../managers/GridDataManager";
import { EventBus, EnumEventBus } from "../managers/EventBus";

export default class LayerGroup extends PIXI.Container {
  static instance: LayerGroup;
  private EventBus = EventBus;
  private Game = Game.getInstance();
  private HowToPlayLayer: HowToPlayLayer;
  constructor() {
    super();
    if (!LayerGroup.instance) {
      LayerGroup.instance = this;
    }

    this.addLayers();
    this.addToGame();

    this.EventBus.on(EnumEventBus.setHowToPlayMode, booleanString => this.setHowToPlay(JSON.parse(booleanString)));
  }

  addLayers() {
    new MiddleLayer();
    new TopLayer();
    new UILayer();
    this.HowToPlayLayer = new HowToPlayLayer();
    this.HowToPlayLayer.visible = false;

    new GridDataManager();
  }
  setHowToPlay(boolean) {
    if (boolean) {
      this.HowToPlayLayer.visible = true;
      this.HowToPlayLayer.start();
    } else {
      this.HowToPlayLayer.visible = false
    }
  }
  addHowToPlay() {
  }
  removeHowToPlay() {
    this.HowToPlayLayer.removeChild(this.HowToPlayLayer);
    this.HowToPlayLayer.removeChildren();
    this.HowToPlayLayer.destroy({ children: true });
  }
  addToGame() {
    this.Game.addChild(this);
  }
  static getInstance() {
    return LayerGroup.instance;
  }
}